import React, { ReactNode } from 'react';
import { Grid, GridProps } from '@mui/material';
import styled from '@emotion/styled';

type BrowserItemProps = GridProps & {
  active: boolean;
  activeParent?: boolean;
  children: ReactNode;
  onClick: () => void;
};

const BrowserItem = ({ active, activeParent, children, onClick, ...props }: BrowserItemProps) => (
  <Wrapper active={+active} parent={activeParent || undefined} onClick={onClick} {...props}>
    <div>{children}</div>
  </Wrapper>
);

export default BrowserItem;

const Wrapper = styled(Grid)<{ active: number | undefined; parent: BrowserItemProps['activeParent'] | undefined }>`
  width: 100%;
  padding: ${({ theme }) => theme.spacing(1.5)};
  background-color: ${({ theme }) => `${theme.palette.default.main}1a`};
  border: 2px solid transparent;
  margin-bottom: ${({ theme }) => theme.spacing(1.25)};
  transition: ease 300ms background-color;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;

  ${({ theme, active }) =>
    !!active &&
    `
    background-color: ${theme.palette.primary.main}3a;
    border-color: ${theme.palette.primary.main}9a;
    & .MuiTypography-subtitle2 {
      opacity: 0.7;
    }
    &:hover {
      background-color: ${theme.palette.primary.main}3a;
    }
  `}

  ${({ theme, parent }) =>
    parent &&
    `
    border-color: ${theme.palette.primary.main}3a;
  `}

  & .MuiTypography-root {
    line-height: 1;
  }

  & .MuiTypography-subtitle2 {
    font-size: 1rem;
    display: inline-block;
    opacity: 0.5;
  }

  &:hover {
    background-color: ${({ theme }) => `${theme.palette.default.main}3a`};
    transition: ease 300ms background-color;
  }
`;
